import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { TeleopJoystickPosition } from "@formant/core/model/TeleopJoystickPosition";
import { Icon } from "@formant/ui/component/common/Icon";

import { TeleopActions } from "../../../TeleopActions";
import { Label } from "./Label";
import * as styles from "./Labels.scss";

export interface ILabelsProps {
    position?: TeleopJoystickPosition;
    className?: string;
    targetRef?: React.RefObject<HTMLDivElement>;
    armed: boolean;
    onStop: () => void;
}

@observer
export class Labels extends Component<ILabelsProps> {
    @observable
    private downKeys: string[] = [];

    public render() {
        const { position, className, armed, targetRef } = this.props;
        const { downKeys } = this;

        if (position === undefined) {
            return false;
        }

        return (
            <div
                className={classnames(styles.labels, className)}
                ref={targetRef}
            >
                <TeleopActions
                    onDownKeysChanged={this.onDownKeysChanged}
                    onStop={this.handleStop}
                />
                {position === "right" && (
                    <>
                        <Label
                            position="top"
                            active={armed && downKeys.includes("arrowup")}
                        >
                            <Icon name="arrow-up" size="18" />
                        </Label>
                        <Label
                            position="right"
                            active={armed && downKeys.includes("arrowright")}
                        >
                            <Icon name="arrow-right" size="18" />
                        </Label>
                        <Label
                            position="bottom"
                            active={armed && downKeys.includes("arrowdown")}
                        >
                            <Icon name="arrow-down" size="18" />
                        </Label>
                        <Label
                            position="left"
                            active={armed && downKeys.includes("arrowleft")}
                        >
                            <Icon name="arrow-left" size="18" />
                        </Label>
                    </>
                )}
                {position === "left" && (
                    <>
                        <Label
                            position="top"
                            active={armed && downKeys.includes("w")}
                        >
                            W
                        </Label>
                        <Label
                            position="right"
                            active={armed && downKeys.includes("d")}
                        >
                            D
                        </Label>
                        <Label
                            position="bottom"
                            active={armed && downKeys.includes("s")}
                        >
                            S
                        </Label>
                        <Label
                            position="left"
                            active={armed && downKeys.includes("a")}
                        >
                            A
                        </Label>
                    </>
                )}
            </div>
        );
    }

    private onDownKeysChanged = (downKeys: string[]) => {
        this.downKeys = downKeys;
    };

    private handleStop = () => {
        this.props.onStop();
    };
}
